module.exports = "/assets/dist/img/drag-circle.svg?fd0f02049d58391cb5c970418ef72a6c";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/shared/svg/drag-circle.svg
// module id = 849
// module chunks = 0 2